import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { RmEvaluationSamples } from "./rm-evaluation-samples.entity";

@Entity('rm_evaluation')
export class RmEvaluation{

    @PrimaryGeneratedColumn('increment', {name: 'rm_evaluation_id'})
    rmEvaluationId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'grn_id'
    })
    grnId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'grn_item_id'
    })
    grnItemId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'vehicle_id'
    })
    vehicleId: number;

    @Column({
        nullable: false,
        name: 'arrival_time'
    })
    arrivalTime: Date;

    @Column({
        nullable: false,
        name: 'start_time_of_obsv'
    })
    startTimeOfObv: Date;

    @Column({
        type: 'int',
        nullable: false,
        name: 'frequency'
    })
    freqencyOfInsp: number;

    @Column('varchar',{
        nullable: false,
        length: 30,
        name: 'batch_number'
    })
    batchNumber: string;
    
    @Column('varchar',{
        nullable: false,
        length: 30,
        name: 'source_code'
    })
    centerOrSourceCode: string;


    @Column({
        type: 'int',
        nullable: false,
        name: 'total_quantity'
    })
    totalQuantity: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'no_of_samples'
    })
    noOfSamplesDrawn: number;

    @Column("varchar", {
        nullable: false,
        length: 60,
        name: "remarks"
    })
    remarks: string;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => RmEvaluationSamples, samples => samples.rmEvaluationInfo, {cascade: true})
    RmEvalSamplesInfo: RmEvaluationSamples[];

}